import { render, staticRenderFns } from "./BarChart1.vue?vue&type=template&id=4550613c&scoped=true&"
import script from "./BarChart1.vue?vue&type=script&lang=js&"
export * from "./BarChart1.vue?vue&type=script&lang=js&"
import style0 from "./BarChart1.vue?vue&type=style&index=0&id=4550613c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4550613c",
  null
  
)

export default component.exports